module.exports = __webpack_public_path__ + "static/media/prof.47971312.png";